import getUrl from '@utils/url-utils'

import {baseApi} from './base.slice'

export type filterProperty = {
	property: string
	value: string
}
export const orderApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getOrders: builder.query<
			GetOrdersResponse,
			{
				offset: number
				limit: number
				tenantId: string
				code: string
				filters: filterProperty[]
			}
		>({
			query: ({offset, limit, tenantId, code, filters}) => {
				const url = getUrl(`${process.env.GATSBY_BACKOFFICE_BASE_URL}/orders`, {
					queryParams: new Map([
						['code', code],
						['limit', limit.toString()],
						['offset', offset.toString()],
					]),
				})

				url.searchParams.set(`tenantId`, tenantId)
				filters.forEach((filter) => {
					url.searchParams.set(`${filter?.property}[in]`, filter?.value)
				})
				url.searchParams.set(`orderBy`, 'createdAt.desc')

				return {
					input: url.toString(),
					init: {method: 'GET'},
				}
			},
			providesTags: ['Orders'],
		}),

		getOrder: builder.query<OrderDetail, {orderId: string}>({
			query: ({orderId}) => {
				const url = getUrl(
					`${process.env.GATSBY_BACKOFFICE_BASE_URL}/orders/${orderId}`
				)

				return {
					input: url.toString(),
					init: {method: 'GET'},
				}
			},
		}),
		completeOrder: builder.mutation<null, {orderId: string}>({
			query: ({orderId}) => {
				return {
					input: `${process.env.GATSBY_BACKOFFICE_BASE_URL}/orders/${orderId}/complete`,
					init: {method: 'PUT'},
				}
			},
			invalidatesTags: ['Orders', 'PlayerPrizes'],
		}),
		completeTransit: builder.mutation<null, {orderId: string}>({
			query: ({orderId}) => {
				return {
					input: `${process.env.GATSBY_BACKOFFICE_BASE_URL}/orders/${orderId}/complete-transit`,
					init: {method: 'PUT'},
				}
			},
			invalidatesTags: ['Orders', 'PlayerPrizes'],
		}),
		refundPrize: builder.mutation<null, {id: string}>({
			query: ({id}) => {
				return {
					input: `${process.env.GATSBY_BACKOFFICE_BASE_URL}/purchasedprizes/${id}/refund`,
					init: {method: 'PUT'},
				}
			},
			invalidatesTags: ['Orders', 'PlayerPrizes'],
		}),
		revertPrize: builder.mutation<null, {id: string}>({
			query: ({id}) => {
				return {
					input: `${process.env.GATSBY_BACKOFFICE_BASE_URL}/purchasedprizes/${id}/revert`,
					init: {method: 'PUT'},
				}
			},
			invalidatesTags: ['Orders', 'PlayerPrizes'],
		}),

		completeExpiredOrder: builder.mutation<null, {orderId: string}>({
			query: ({orderId}) => {
				return {
					input: `${process.env.GATSBY_BACKOFFICE_BASE_URL}/orders/${orderId}/complete-expired`,
					init: {method: 'PUT'},
				}
			},
			invalidatesTags: ['Orders', 'PlayerPrizes'],
		}),
		revertExpiredOrder: builder.mutation<null, {orderId: string}>({
			query: ({orderId}) => {
				return {
					input: `${process.env.GATSBY_BACKOFFICE_BASE_URL}/orders/${orderId}/revert-expired`,
					init: {method: 'PUT'},
				}
			},
			invalidatesTags: ['Orders', 'PlayerPrizes'],
		}),
		revertCompleteExpiredOrder: builder.mutation<null, {orderId: string}>({
			query: ({orderId}) => {
				return {
					input: `${process.env.GATSBY_BACKOFFICE_BASE_URL}/orders/${orderId}/revert-complete-expired`,
					init: {method: 'PUT'},
				}
			},
			invalidatesTags: ['Orders', 'PlayerPrizes'],
		}),
		cancelOrder: builder.mutation<null, {orderId: string}>({
			query: ({orderId}) => {
				return {
					input: `${process.env.GATSBY_BACKOFFICE_BASE_URL}/orders/${orderId}/cancel`,
					init: {method: 'PUT'},
				}
			},
			invalidatesTags: ['Orders', 'PlayerPrizes'],
		}),
	}),
})

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints.
 */
export const {
	useLazyGetOrderQuery,
	useGetOrdersQuery,
	useLazyGetOrdersQuery,
	useCompleteTransitMutation,
	useCompleteOrderMutation,
	useCompleteExpiredOrderMutation,
	useRevertExpiredOrderMutation,
	useRevertCompleteExpiredOrderMutation,
	useRefundPrizeMutation,
	useRevertPrizeMutation,
	useCancelOrderMutation,
} = orderApi
export default orderApi.reducer
